// components imports
import { LoginComponent } from './login/login';
import { LoginAppComponent } from './login-app/login-app';

export const components: any[] = [
  // components export
  LoginComponent,
  LoginAppComponent,
];
